import pagesAuthInvitationEn from './invitation/default';

const pagesAuthEn = {
  additionalAuth: {
    backToSignIn: 'Back to Sign in',
    cancel: 'Cancel',
    description: 'Please complete multi-factor authentication to continue.',
    loading: 'Loading...',
    sendCodeSubmit: {
      chooseAddress: 'Choose where to send the code',
    },
    title: 'Additional Authentication Required',
    totpSetupDescription:
      'To set up multi-factor authentication, please configure TOTP in your authenticator app.',
  },
  common: {
    privacyPolicy: 'Privacy Policy',
    termOfService: 'Terms of Service',
  },
  flowExpired: {
    description:
      'Too much time has passed, so the form has been reset for security. Please try again.',
    title: 'Your session has expired',
  },
  invitation: pagesAuthInvitationEn,
  ory: {
    '1010001': 'Sign in',
    // Login (101xxxx)
    '1010002': 'Sign in with {provider}',
    '1010003': 'Please confirm this action by verifying that it is you.',
    '1010004': 'Please complete the second authentication challenge.',
    '1010005': 'Verify',
    '1010006': 'Authentication code',
    '1010007': 'Backup recovery code',
    '1010008': 'Sign in with hardware key',
    '1010009': 'Use Authenticator',
    '1010010': 'Use backup recovery code',
    '1010011': 'Sign in with hardware key',
    '1010012':
      'Prepare your WebAuthn device (e.g. security key, biometrics scanner, ...) and press continue.',
    '1010013': 'Continue',
    '1010014':
      "A code was sent to the address you provided. If you didn't receive it, please check the spelling of the address and try again.",
    '1010015': 'Send sign in code',
    '1010016':
      'You tried to sign in with "{duplicateIdentifier}", but that email is already used by another account. Sign in to your account with one of the options below to add your account "{duplicateIdentifier}" at "{provider}" as another way to sign in.',
    '1010017': 'Sign in and link',
    '1010018': 'Confirm with {provider}',
    '1010019': 'Request code to continue',
    '1010021': 'Sign in with passkey',
    '1010022': 'Sign in with password',
    '1010023': 'Send code',
    '1040001': 'Sign up',
    // Registration (104xxxx)
    '1040002': 'Sign up with {provider}',
    '1040003': 'Continue',
    '1040004': 'Sign up with security key',
    '1040005':
      'A code has been sent to the address(es) you provided. If you have not received a message, check the spelling of the address and retry the registration.',
    '1040006': 'Send sign up code',
    '1040007': 'Sign up with passkey',
    '1040008': 'Back',
    '1040009': 'Please choose a credential to authenticate yourself with.',
    '1050001': 'Your changes have been saved!',
    // Settings (105xxxx)
    '1050002': 'Link {provider}',
    '1050003': 'Unlink {provider}',
    '1050004': 'Unlink TOTP Authenticator App',
    '1050005': 'Authenticator app QR code',
    '1050006': '{secret}',
    '1050007': 'Reveal backup recovery codes',
    '1050008': 'Generate new backup recovery codes',
    '1050009': '{secret}',
    '1050010':
      'These are your back up recovery codes. Please keep them in a safe place!',
    '1050011': 'Confirm backup recovery codes',
    '1050012': 'Add security key',
    '1050013': 'Name of the security key',
    '1050014': 'Secret was used at {used_at}',
    '1050015': '{secrets_list}',
    '1050016': 'Disable this method',
    '1050017':
      'This is your authenticator app secret. Use it if you can not scan the QR code.',
    '1050018': 'Remove security key "{display_name}"',
    '1050019': 'Add passkey',
    '1050020': 'Remove passkey "{display_name}"',
    '1060001':
      'You successfully recovered your account. Please change your password or set up an alternative login method (e.g. social sign in) within the next 1.00 minutes.',
    // Recovery (106xxxx)
    '1060002':
      'An email containing a recovery link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.',
    '1060003':
      'An email containing a verification code has been sent to the email address you provided. If you have not received an email, check your spam/junk folder, verify the spelling of the address, and make sure to use the address you registered with.',
    '1060004':
      'A verification code has been sent to {masked_address}. If you have not received it, check your spam/junk folder, verify the spelling of the address, and make sure to use the address you registered with.',
    '1060005':
      'Recover access to your account by providing your recovery address in full.',
    '1060006': 'How do you want to recover your account?',
    '1060007': 'Back',
    '1070001': 'Password',
    // Common UI (107xxxx)
    '1070002': '{title}',
    '1070003': 'Save',
    '1070004': 'ID',
    '1070005': 'Submit',
    '1070006': 'Verify code',
    '1070007': 'Email',
    '1070008': 'Resend code',
    '1070009': 'Continue',
    '1070010': 'Verification code',
    '1070011': 'Verification code',
    '1070012': 'Registration code',
    '1070013': 'Login code',
    '1070014': 'Login and link credential',
    '1070015': 'Please complete the captcha challenge to continue.',
    '1070016': 'Recovery address',
    '1070017': 'Phone number',
    '1080001':
      'An email containing a verification link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.',
    // Verification (108xxxx)
    '1080002': 'You successfully verified your email address.',
    '1080003':
      'An email containing a verification code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.',
    '4000001':
      'The code is invalid or has expired. Please reload the page and try again.',
    // Error Messages (400xxxx)
    '4000002': 'Property {property} is missing.',
    '4000003': 'length must be >= {min_length}, but got {actual_length}',
    '4000004': 'does not match pattern "{pattern}"',
    '4000005': 'The password can not be used because {reason}.',
    '4000006': 'Email address or password is incorrect.',
    '4000007':
      'An account with the same identifier (email, phone, username, ...) exists already.',
    '4000008': 'The provided authentication code is invalid, please try again.',
    '4000009':
      'Could not find any login identifiers. Did you forget to set them? This could also be caused by a server misconfiguration.',
    '4000010':
      'Account not active yet. Did you forget to verify your email address?',
    '4000011': 'You have no TOTP device set up.',
    '4000012': 'This backup recovery code has already been used.',
    '4000013': 'You have no WebAuthn device set up.',
    '4000014': 'You have no backup recovery codes set up.',
    '4000015': 'This account does not exist or has no security key set up.',
    '4000016': 'The backup recovery code is not valid.',
    '4000017': 'length must be <= {max_length}, but got {actual_length}',
    '4000018': 'must be >= {minimum} but found {actual}',
    '4000019': 'must be > {minimum} but found {actual}',
    '4000020': 'must be <= {maximum} but found {actual}',
    '4000021': 'must be < {maximum} but found {actual}',
    '4000022': '{actual} not multipleOf {base}',
    '4000023':
      'maximum {max_items} items allowed, but found {actual_items} items',
    '4000024':
      'minimum {min_items} items allowed, but found {actual_items} items',
    '4000025': 'items at index {index_a} and {index_b} are equal',
    '4000026': 'expected {allowed_types_list}, but got {actual_type}',
    '4000027':
      'An account with the same identifier (email, phone, username, ...) exists already. Please sign in to your existing account to link your social profile.',
    '4000028':
      'You tried signing in with {credential_identifier_hint} which is already in use by another account. You can sign in using {available_credential_types_list}. You can sign in using one of the following social sign in providers: {available_oidc_providers_list}.',
    '4000029': 'must be equal to constant {expected}',
    '4000030': 'const failed',
    '4000031':
      'The password can not be used because it is too similar to the identifier.',
    '4000032':
      'The password must be at least {min_length} characters long, but got {actual_length}.',
    '4000033':
      'The password must be at most {max_length} characters long, but got {actual_length}.',
    '4000034':
      'The password has been found in data breaches and must no longer be used.',
    '4000035':
      'This account does not exist or has not setup sign in with code.',
    '4000036':
      'The provided traits do not match the traits previously associated with this flow.',
    '4000037': 'This account does not exist or has no login method configured.',
    '4000038': 'Captcha verification failed, please try again.',
    '4000039': 'The new password must be different from the old password.',
    '4000040': 'Enter a valid email address',
    '4000041': 'Enter a valid phone number',
    '4010001': 'The login flow expired {expired_at} ago, please try again.',
    // Login Errors (401xxxx)
    '4010002':
      'Could not find a strategy to log you in with. Did you fill out the form correctly?',
    '4010003':
      'Could not find a strategy to sign you up with. Did you fill out the form correctly?',
    '4010004':
      'Could not find a strategy to update your settings. Did you fill out the form correctly?',
    '4010005':
      'Could not find a strategy to recover your account with. Did you fill out the form correctly?',
    '4010006':
      'Could not find a strategy to verify your account with. Did you fill out the form correctly?',
    '4010007':
      'The request was already completed successfully and can not be retried.',
    '4010008':
      'The login code is invalid or has already been used. Please try again.',
    '4010009': 'Linked credentials do not match.',
    '4010010':
      'The address you entered does not match any known addresses in the current account.',
    '4040001':
      'The registration flow expired {expired_at} ago, please try again.',
    // Registration Errors (404xxxx)
    '4040002':
      'The request was already completed successfully and can not be retried.',
    '4040003':
      'The registration code is invalid or has already been used. Please try again.',
    '4050001': 'The settings flow expired {expired_at} ago, please try again.',
    // Settings Errors (405xxxx)
    '4060001':
      'The request was already completed successfully and can not be retried.',
    // Recovery Errors (406xxxx)
    '4060002': 'The recovery flow reached a failure state and must be retried.',
    '4060004':
      'The recovery token is invalid or has already been used. Please retry the flow.',
    '4060005': 'The recovery flow expired {expired_at} ago, please try again.',
    '4060006':
      'The verification code is invalid or has already been used. Please try again.',
    '4070001':
      'The verification token is invalid or has already been used. Please retry the flow.',
    // Verification Errors (407xxxx)
    '4070002':
      'The request was already completed successfully and can not be retried.',
    '4070003':
      'The verification flow reached a failure state and must be retried.',
    '4070005':
      'The verification flow expired {expired_at} ago, please try again.',
    '4070006':
      'The verification code is invalid or has already been used. Please try again.',
    '5000001': '{reason}',
    // System Errors (500xxxx)
    '5000002':
      'No authentication methods are available. Please contact the system administrator.',
    error: {
      browser_location_change_required: 'Redirecting to the required location.',
      security_csrf_violation:
        'A security violation was detected, please fill out the form again.',
      security_identity_mismatch:
        'The requested item was intended for someone else. Please start a new flow.',
      self_service_flow_expired:
        'Your interaction expired, please fill out the form again.',
      self_service_flow_return_to_forbidden:
        'The return_to address is not allowed.',
      session_aal2_required:
        'Step-up authentication (AAL2) is required to perform this action.',
      session_already_available:
        'You are already signed in. Redirecting to home page.',
      session_inactive: 'Your session is inactive. Please sign in again.',
      session_refresh_required:
        'The login session is too old and thus not allowed to update these fields. Please re-authenticate.',
    },
    // Ory Error IDs and Reasons
    mfa: {
      code: 'Email Code (MFA)',
      totp: 'Authenticator App (TOTP)',
    },
  },
  passwordStrengthError:
    'Password must be at least 10 characters and include uppercase, lowercase, number, and symbol.',
  reauth: {
    cancel: 'Cancel',
    description:
      'Your session has expired. Please re-authenticate to continue.',
    title: 'Re-authentication Required',
  },
  reset: {
    requestVerify: {
      backToSignIn: "Back to <Link to='/auth' className=''>Sign in</Link>",
      description:
        "Enter your email address and we'll send you a verification code to reset your password.",
      email: 'Email',
      limitExceededError:
        'The reset password limit has been exceeded. Please try again later.',
      sendButton: 'Send',
      successDescription:
        "If you don't receive the email, the user may not be registered or not yet verified. Please contact your administrator.",
      successMessage: 'Password reset email has been sent',
      title: 'Forgot Password?',
      userNotFoundError: 'User not found.',
    },
  },
  secureGuard: {
    cancel: 'Cancel',
    description:
      'This action requires additional verification. Please complete multi-factor authentication to continue.',
    passwordTitle: 'Password Required',
    title: 'Verification Required',
  },
  showPassword: 'Show password',
  signIn: {
    accountDeactivated:
      "This account has been deactivated. Please contact your organization's administrator.",
    description:
      'Organize every workflow so that anyone can execute them comfortably and naturally.',
    forgotPassword: 'Forgot password?',
    ssoError: {
      defaultMessage: 'An error occurred during SSO sign-in. Please try again.',
      guidance: {
        contactAdmin:
          "If you need access, ask your organization's administrator to send you an invitation.",
        linkViaSettings:
          'Sign in with your email and password, then link SSO from your account settings.',
        retry: 'Linking failed. Please try signing in with SSO again.',
      },
      retryButton: 'Back to Sign In',
      title: 'Sign-in Failed',
    },
    tabs: {
      password: 'Password',
      sso: 'SSO',
    },
    title: 'Sign In',
  },
  /**
   * Ory Kratos 認証フロー用の翻訳キー
   * meta.label.id から翻訳を取得する際に使用
   *
   * Ory KratosのIDベースの翻訳:
   * - 数値ID（例: "1070002"）をキーとして使用
   * - 翻訳が見つからない場合は meta.label.text（Ory Kratosのデフォルトテキスト）を使用
   *
   * @see https://www.ory.com/docs/kratos/concepts/ui-user-interface#ui-message-codes
   */
};

export default pagesAuthEn;
